
import {
  Vue, Component, Prop, Ref,
} from 'vue-property-decorator';
import { FILE_ACCEPT } from '@/features/shipment/types/documentType';

@Component
export default class DocumentDropZone extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isDisabled!: boolean;

  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean;

  @Ref('fileInput') fileInputRef!: HTMLInputElement;

  // eslint-disable-next-line global-require
  private uploadIconSrc = require('@/assets/images/electronic-trade-documents/upload-icon.svg');

  private isDragOver = false;

  private fileAccept = FILE_ACCEPT;

  private onDragOver(): void {
    if (this.isDisabled) return;
    this.isDragOver = true;
  }

  private onDragLeave(): void {
    this.isDragOver = false;
  }

  private onDrop(event: DragEvent): void {
    this.isDragOver = false;
    if (this.isDisabled) return;

    const files = event.dataTransfer?.files;
    if (files && files.length) {
      this.$emit('files-selected', Array.from(files));
    }
  }

  private openFilePicker(): void {
    if (this.isDisabled) return;
    this.fileInputRef.click();
  }

  private onFileInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.$emit('files-selected', Array.from(input.files));
    }
    // Reset so the same file can be re-selected
    input.value = '';
  }
}
